import { Box } from '@mui/material'
import { useLocation, useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import { useAuthStore } from '@/features/auth'
import { getVisibleNavItems } from './navItems'
import SidebarButton from './SidebarButton'
import iconLogout from '@/assets/icons/icon_logout.svg'

const Sidebar = () => {
    const { pathname } = useLocation()
    const navigate = useNavigate()
    const { t } = useTranslation()
    const { logout, userProfile } = useAuthStore()
    const visibleItems = getVisibleNavItems(userProfile?.roles)

    return (
        <Box
            sx={{
                position: 'fixed',
                left: 38,
                top: 54,
                height: 'calc(100vh - 54px - 80px)',
                minHeight: 534,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: 48,
                zIndex: 1000,
            }}
        >
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2.5, width: '100%' }}>
                {visibleItems.map((item) => (
                    <SidebarButton
                        key={item.path}
                        icon={item.icon}
                        label={t(item.labelKey)}
                        selected={!item.disabled && pathname === item.path}
                        disabled={item.disabled}
                        onClick={() => { if (!item.disabled) navigate(item.path) }}
                    />
                ))}
            </Box>
            <Box sx={{ flexGrow: 1 }} />
            <SidebarButton
                icon={iconLogout}
                label={t('logout')}
                onClick={logout}
            />
        </Box>
    )
}

export default Sidebar
